export default __webpack_public_path__ + "static/media/ger.cf16b1b6.svg";